import styled from "styled-components";




export const ChallengesContainer = styled.div`
  width: 100%;
  ${'' /* padding: 0 25px; */}
  width: 100%;
  max-width: 1248px;
  margin: auto;
  padding-top: 25px;
  ${'' /* > div {
    width: 100%;
    max-width: 1248px;
    margin: auto;
    padding-top: 25px;
  } */}
`;


export const WeekWrapper = styled.div`
.dayText{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  ${'' /* font-size: 14px; */}
  font-size:${({isDayText})=> isDayText ? isDayText : '14px'};
  font-style: normal;
  font-weight: ${({isDayWeight})=> isDayWeight ? isDayWeight : '700'};
  ${'' /* font-weight: 700; */}
  line-height: 20px; 
    margin-bottom: 8px;
}
`;





export const WeekContainer = styled.div`

display:flex;
justify-content: space-between;
.weeekText{
color:  #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
}
`;


export const OptionsContainer = styled.div`


.questionsText{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #F8F8F8;
  border-radius: 50%;
  font-weight: bold;
  font-size: 14px;
  color: #184A61;
  flex-shrink: 0;


  ${'' /* display: flex;
  width: 40px;
  height: 40px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--Bg-Color-for-Light-theme-500, #F8F8F8); */}

.questionsNumber{
  width: 12px;
  height: 24px;
  flex-shrink: 0;
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; 
}
}
`;


export const MoreOptionText = styled.div`
  color:  #F37A65;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin:16px 20px;
`;



export const ToggleWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 24px;
  padding: 2px;
  align-items: center;
  border-radius: 12px;
  border: 1px solid  #EFEFEF;
  background: ${(props) =>
    props.active
      ? " #F37A65"
      : " #EFEFEF"};
  cursor: pointer;
  transition: background 0.3s ease-in-out;
`;

export const ToggleCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
 
  background: ${({ active }) =>
    active
      ? "#FFFFFF"
      :  "#BDBDBD"};
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.active ? "translateX(16px)" : "translateX(0)")};
`;


export const ToggleContainer = styled.div`
    display: flex;
    gap:12px;

    .respondsText{
       color:  #184A61;
       font-family: Lato;
       font-size: 16px;
       font-style: normal;
       font-weight: 400;
       line-height: 20px; 
    }
`;



export const ActionButton = styled.div`
    display: flex;
    width:200px;
    height: 40px;
    margin-top:20px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    flex: 1;
    ${'' /* max-width: calc(50% - 8px);  */}
    border:${({isBorderColor})=> isBorderColor ? isBorderColor : '1px solid #F37A65'};
    ${'' /* border: 1px solid #F37A65; */}
    border-radius: 4px;
    background: transparent;
    color: #184A61;
    font-family: 'Lato';
    font-size: 16px;
    font-style: normal;
    font-weight: 400; 
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    cursor: pointer;
    box-sizing: border-box;
`;

